const locale = {
  CANCEL_BUTTON: 'Cancelar',
  DONE_BUTTON: 'Listo',
};

export default locale;
